<template>
  <default-layout>
    <template slot="center">
      <modal-component :modal="true" v-on:close="showModal = false" v-if="showModal">
        <div class="white-card" style="max-width: 800px;margin: 0 auto;padding: 20px">
          <image-list :images="images"/>
        </div>
      </modal-component>
      <div class="white-card" style="min-height: 30vh">
        <div class="loader absolute" v-if="loading"></div>
        <template v-else-if="exam">
          <h3 class="mb-4">{{ exam.title }}</h3>

          <div class="d-flex justify-content-between">
            <div class=" card-text d-flex flex-column ">
              <a href="#" class="btn btn-green my-2" @click.prevent="setShowExam">Voir l'épreuve</a>
              <a download="" v-if="exam.download" :href="exam.resume_download" class="btn btn-green my-2">Télécharger
                l'épreuve</a>
            </div>
            <div class=" card-text d-flex flex-column">
              <a href="#" class="btn btn-green my-2" @click.prevent="setShowSolution">Voir le corrigé</a>
              <a download="" v-if="exam.download" :href="exam.solution_download" class="btn btn-green my-2">Télécharger
                le corrigé</a>
            </div>
          </div>
        </template>
      </div>
    </template>
  </default-layout>
</template>

<script>
import DefaultLayout from "@/Layout/DefaultLayout";
import axios from "axios";
import ModalComponent from "@/components/LayoutPartials/ModalComponent";
import ImageList from "@/components/Lesson/ImageList";

export default {
  components: {ImageList, ModalComponent, DefaultLayout},
  data() {
    return {
      showModal: false,
      loading: false,
      exam: null,
      images: []
    }
  },
  watch: {
    '$route.params.slug'() {
      this.load()
    }
  },
  methods: {
    setShowSolution() {
      this.showModal = true;
      this.images = this.exam.solution
    },
    setShowExam() {
      this.showModal = true;
      this.images = this.exam.resume;
    },
    load() {
      this.loading = true
      axios.get('/exam/' + this.$slugId(this.$route.params.slug))
        .then(({data}) => {
          this.exam = data
        })
        .finally(() => this.loading = false)
    }
  },
  created() {
    this.load()
  }
}
</script>
